
// import React from 'react';

// const universities = [
//   {
//     id: 1,
//     university: "University College Dublin",
//     img: "irreland3.jpeg",
//     location: "Ireland",
//   },
//   {
//     id: 2,
//     university: "Silesian University",
//     img: "poland-img2.jpeg",
//     location: "Poland",
//   },
//   {
//     id: 3,
//     university: "Trinity College",
//     img: "irreland2.jpeg",
//     location: "Ireland",
//   },
//   {
//     id: 4,
//     university: "University of Galway",
//     img: "ireland1.jpeg",
//     location: "Ireland",
//   },
//   {
//     id: 5,
//     university: "Lublin University ",
//     img: "poland 3.jpg",
//     location: "Poland",
//   },
//   {
//     id: 6,
//     university: "University of Aberdeen",
//     img: "uk-images.jpeg",
//     location: "London",
//   },
//   {
//     id: 7,
//     university: "Abertay University",
//     img: "ukimages2.jpeg",
//     location: "London",
//   },
//   {
//     id: 8,
//     university: "SGH University",
//     img: "poland university.jpeg",
//     location: "Poland",
//   },
// ];



// const UniversityList = () => {
//   return (
//     <>
//       <h2 className="text-2xl font-bold text-center mb-4 text-purple-900 p-4">TOP UNIVERSITIES</h2>
//       <div className="flex overflow-x-auto snap-x snap-mandatory gap-6 p-6">
//         {universities
//         .map((university, index) => (
//           <div
//             key={index}
//             className="carousel-item snap-center flex-shrink-0 hover:bg-gradient-to-r from-purple-400 via-pink-500 to-red-500 w-60 h-60 flex flex-col items-center bg-white rounded-lg shadow-lg shadow-customPurpl p-6">
//             <img src={university.img} className='h-20 w-20 rounded-full p-1 '/>
//             <h4 className="mt-10 text-lg text-center font-semibold hover:text-purple-100 text-purple-500">{university.university}</h4>
//             <h2 className="pt-2 text-lg text-center font-bold text-purple-900">{university.location}</h2>
//           </div>
//         ))}
//       </div>
//     </>
//   );
// };

// export default UniversityList;
// import { useRef } from "react";

// const universities = [
//   {
//     id: 1,
//     university: "University College Dublin",
//     img: "/university-images/irreland1.jpeg",
//     location: "Ireland",
//   },
//   {
//     id: 2,
//     university: "Silesian University",
//     img: "/university-images/poland1.jpeg",
//     location: "Poland",
//   },
//   {
//     id: 3,
//     university: "Trinity College",
//     img: "/university-images/irreland2.jpeg",
//     location: "Ireland",
//   },
//   {
//     id: 4,
//     university: "University of Galway",
//     img: "/university-images/irreland3.jpeg",
//     location: "Ireland",
//   },
//   {
//     id: 5,
//     university: "Lublin University ",
//     img: "/university-images/poland2.jpeg",
//     location: "Poland",
//   },
//   {
//     id: 6,
//     university: "University of Aberdeen",
//     img:"/university-images/london2.jpeg",
//     location: "London",
//   },
//   {
//     id: 7,
//     university: "Abertay University",
//     img: "/university-images/london1.jpeg",
//     location: "London",
//   },
//   {
//     id: 8,
//     university: "SGH University",
//     img: "/university-images/poland3.jpeg",
//     location: "Poland",
//   },
// ];

// const UniversityList = () => {
//   const carouselRef = useRef(null);

//   // Scroll to the previous set of items
//   const scrollLeft = () => {
//     if (carouselRef.current) {
//       carouselRef.current.scrollBy({
//         left: -300,
//         behavior: "smooth",
//       });
//     }
//   };

//   // Scroll to the next set of items
//   const scrollRight = () => {
//     if (carouselRef.current) {
//       carouselRef.current.scrollBy({
//         left: 300,
//         behavior: "smooth",
//       });
//     }
//   };

//   return (
//     <div className="relative">
//       <h2 className="text-2xl font-bold text-center  text-purple-900 p-2">
//         TOP UNIVERSITIES
//       </h2>
//       <p className="p-4 text-stone-500 font-semibold"> At MATT, we take pride in providing high-quality PhD assignment assistance to students from top-ranked universities worldwide. Our team of subject-matter experts understands the unique challenges of doctoral-level research and academic writing. With our tailored support, students can confidently tackle complex assignments, research papers, and dissertations.

//  MATT is here to help you achieve academic excellence. Thousands of PhD candidates from leading   <p className="text-center">universities trust our services to ensure they meet the highest standards in their academic work.</p>
//  </p>

//       {/* Carousel Container */}
//       <div className="flex items-center justify-center">
//         {/* Left Arrow Button */}
//         <button
//           onClick={scrollLeft}
//           className="absolute left-0 z-10 p-2 bg-purple-900 text-white border  rounded-full shadow-md focus:outline-none"
//         >
//           &#8249;
//         </button>

//         {/* Carousel Items */}
//         <div
//           className="flex overflow-x-auto snap-x snap-mandatory gap-6 p-6 scroll-smooth"
//           ref={carouselRef}
//         >
//           {universities.map((university, index) => (
//             <div
//               key={index}
//               className="carousel-item snap-center flex-shrink-0 hover:bg-gradient-to-r from-purple-400 via-pink-500 to-red-500 w-60 h-60 flex flex-col items-center bg-white rounded-lg shadow-lg shadow-customPurpl p-6"
//             >
//               <img
//                 src={university.img}
//                 alt={university.university}
//                 className="h-32 w-32 rounded-full p-1"
//               />
//               <h4 className="mt-10 text-lg text-center font-semibold hover:text-purple-100 text-purple-500">
//                 {university.university}
//               </h4>
//               <h2 className="pt-2 text-lg text-center font-bold text-purple-900">
//                 {university.location}
//               </h2>
//             </div>
//           ))}
//         </div>

//         {/* Right Arrow Button */}
//         <button
//           onClick={scrollRight}
//           className="absolute  right-0 z-10 p-2 bg-purple-900 text-white border rounded-full shadow-md focus:outline-none "
//         >
//           &#8250;
//         </button>
//       </div>
//     </div>
//   );
// };

// export default UniversityList;



import React, { useState } from "react";
import { Card, CardMedia, CardContent, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import Slider from "react-slick"; // Import the react-slick slider component
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const useStyles = makeStyles({
  card: {
    transition: "all 0.7s ease-in-out",
    position: "relative",
    zIndex: 1,
    width: "280px",
    height: "320px",
    // margin: "0 auto",
    borderRadius: "20px",
    boxShadow: "2px 2px 8px 0px rgba(0, 0, 0, 0.5)",
    // background: "rgba(255, 255, 255, 0.1)", // Semi-transparent background for glass effect,
    backgroundColor:"#012e57",
    backdropFilter: "blur(10px) saturate(180%)", // Frosted glass effect
    
    transformStyle: "preserve-3d", // Needed for 3D animation
    overflow: "hidden",
  },
  cardActive: {
    opacity: 1,
    transform: "", // Larger scale for active card
    zIndex: 5,
    borderRadius: "20px",
    boxShadow: "6px 6px 20px 0px rgba(0, 0, 0, 0.7)",
  },
  cardInactiveLeft: {
    opacity: 0.6,
    transform: "translateX(-40px) scale(0.9)", // Leftward shift and smaller size
    zIndex: 3,
    transition: "all 0.7s ease-in-out",
  },
  cardInactiveRight: {
    opacity: 0.6,
    transform: "translateX(40px) scale(0.9)", // Rightward shift and smaller size
    zIndex: 3,
    transition: "all 0.7s ease-in-out",
  },
  cardInactiveBack: {
    opacity: 0.4,
    transform: "scale(0.8)", // Farthest back cards are smaller
    zIndex: 1,
    transition: "all 0.7s ease-in-out",
  },
  container: {
    width: "100%",
    margin: "50px 0px",
    overflow: "hidden",
  },
  media: {
    height: "220px", // Fixed height for the image section
    objectFit: "cover",
    borderTopLeftRadius: "20px",
    borderTopRightRadius: "20px",
  },
  slickSlide: {
    display: "flex !important", // Ensures the slide content is flex-aligned
    justifyContent: "center",
  },
  cardContent: {
    background: "rgba(255, 255, 255, 0.1)", // Glassy background for text content
    backdropFilter: "blur(10px)", // Frosted effect in the content section
    color: "white",
    borderBottomLeftRadius: "20px",
    borderBottomRightRadius: "20px",
    padding: "10px",
  },
});

// Array of universities
const universities = [
  {
    id: 2,
    university: "Silesian University",
    img: "/university-images/poland1.jpeg",
    location: "Poland",
  },
  {
    id: 3,
    university: "Trinity College",
    img: "/university-images/irreland2.jpeg",
    location: "Ireland",
  },
  {
    id: 4,
    university: "University of Galway",
    img: "/university-images/irreland3.jpeg",
    location: "Ireland",
  },
  {
    id: 5,
    university: "Lublin University",
    img: "/university-images/poland2.jpeg",
    location: "Poland",
  },
  {
    id: 6,
    university: "University of Aberdeen",
    img: "/university-images/london2.jpeg",
    location: "London",
  },
  {
    id: 7,
    university: "Abertay University",
    img: "/university-images/london1.jpeg",
    location: "London",
  },
  {
    id: 8,
    university: "SGH University",
    img: "/university-images/poland3.jpeg",
    location: "Poland",
  },
  
];

const Slideshow = () => {
  const classes = useStyles();
  const [activeIndex, setActiveIndex] = useState(3); // Start with the 4th card (0-indexed)

  // Slider settings for slick-carousel
  const settings = {
    infinite: true,
    speed: 500,
    slidesToShow: 5, // Show 5 cards at a time
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 1000,
    centerMode: true, // Enable center mode to make the center card prominent
    centerPadding: "0px",
    beforeChange: (current, next) => setActiveIndex(next), // Handle index change for card position
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3, // Show 3 cards on medium screens
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1, // Show 1 card on small screens
        },
      },
    ],
  };

  const getCardStyle = (index) => {
    const isActive = index === activeIndex;
    const isNextActive = index === (activeIndex + 1) % universities.length;
    const isPrevActive = index === (activeIndex - 1 + universities.length) % universities.length;

    if (isActive) return classes.cardActive;
    if (isPrevActive) return classes.cardInactiveLeft;
    if (isNextActive) return classes.cardInactiveRight;
    return classes.cardInactiveBack; // Farthest back cards
  };

  return (
    <div className={classes.container}>
      <Slider {...settings}>
        {universities.map((university, index) => (
          <div key={university.university} className={classes.slickSlide}>
            <Card
              className={`${classes.card} ${getCardStyle(index)}`} 
              sx={{ margin: "0 10px", height: "100%", borderRadius: "20px" }}
              
             
            >
              <CardMedia
                component="img"
                className={classes.media} // Ensures consistent media size
                image={university.img}
                alt={university.university}
              />
              <CardContent className={classes.cardContent}>
                <Typography gutterBottom variant="h5" component="div" style={{color:"white",fontWeight:"500"}}>
                  {university.university}
                </Typography>
                <Typography
                  variant="body2"
                  color="white"
                  sx={{
                    background:
                      "linear-gradient(-103deg, rgb(255 255 255 / 0%) -3%, rgb(255 249 220 / 0%) 30%, rgb(255 162 49) 100%, rgb(255 255 255 / 0%) 0%)",
                  }}
                >
                  {university.location}
                </Typography>
              </CardContent>
            </Card>
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default Slideshow;
